// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
const login = () => import("../views/login")
// 首页
const index = () => import("../views/index")
// 
const home = () => import("../views/home/home")

//添加项目
const setting = () => import("@/views/setting/setting")
const gmanage = () => import("@/views/setting/gmanage")
const dmanage = () => import("@/views/setting/dmanage")
const permission = () => import("@/views/setting/permission")

// 
//修改密码
const user = () => import("@/views/account/user")

//个人资料
const role = () => import("@/views/account/role")


/** 
 * 回款项目
*/
const collection = () => import("../views/collection/collection")

/**
 * 收入事件
 * 
 */
 const revenue = () => import("../views/revenue/revenue")


/**
 * 回款统计
 * 
 */
 const statistics = () => import("../views/statistics/statistics")
/**
 *数据检索
 * 
 */
 const dataquery = () => import("../views//dataquerys/dataquery")

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      title:'种子',
      requireAuth: false
    }
  },{
      path: '/index',
      component: index,
      children: [
        {
        path: '/home/home',
        name: '首页',
        component: home,
        meta: {
          title:'种子-首页',
          requireAuth: true
        }
      },{
        path: '/collection/collection',
        name: '禾略伏虎',
        component: collection,
        meta: {
          title:'禾略伏虎-项目管理',
          requireAuth: true,
          keepAlive:false,
          guidePath:false,
          jumpPath:'/screening/mainpage'
        }
      }, {
        path: '/setting/setting',
        name: '项目设置',
        component: setting,
        meta: {
          title:'禾略伏虎-项目设置',
          requireAuth: true
        }
      }, {
        path: '/setting/gmanage',
        name: '团队管理',
        component: gmanage,
        meta: {
          title:'禾略伏虎-团队管理',
          requireAuth: true
        }
      }, {
        path: '/setting/dmanage',
        name: '部门管理',
        component: dmanage,
        meta: {
          title:'禾略伏虎-部门管理',
          requireAuth: true
        }
      }, {
        path: '/setting/permission',
        name: '权限组',
        component: permission,
        meta: {
          title:'禾略伏虎-权限组',
          requireAuth: true
        }
      },{
        path: '/account/user',
        name: '修改密码',
        component: user,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/account/role',
        name: '个人资料',
        component: role,
        meta: {
          requireAuth: true
        }
      },{
        path: '/revenue/revenue',
        name: '禾略伏虎-收支管理',
        component: revenue,
        meta: {
          title:'禾略伏虎-收支管理',
          requireAuth: true,
          keepAlive:false,
          // guidePath:false,
          // jumpPath:'/screening/mainpage'
        }
      },{
        path: '/statistics/statistics',
        name: '禾略伏虎-统计',
        component: statistics,
        meta: {
          title:'禾略伏虎-统计',
          requireAuth: true,
          keepAlive:false,
          // guidePath:false,
          // jumpPath:'/screening/mainpage'
        }
      },{
        path: '/dataquery/dataquery',
        name: '禾略伏虎-数据查询',
        component: dataquery,
        meta: {
          title:'禾略伏虎-数据查询',
          requireAuth: true,
          keepAlive:false,
          // guidePath:false,
          // jumpPath:'/screening/mainpage'
        }
      },]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js